import MatterEmails from "@/components/features/matter/emails/MatterEmails";
import { useRedirectIfMatterDeleted } from "@/hooks/useRedirectIfMatterDeleted";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { z } from "zod";

export const Route = createFileRoute("/_auth/matters/$matterId/_layout/emails")(
  {
    component: RouteComponent,
    validateSearch: z.object({
      emailId: z.string().optional(),
    }),
  },
);

function RouteComponent() {
  const { matterId } = Route.useParams();
  const { emailId } = Route.useSearch();
  const navigate = Route.useNavigate();
  const { data: matterDetails } = useSuspenseQuery(
    retrieveMatterQueryOptions(matterId),
  );

  const handleSelectedEmailIdChange = useCallback(
    (nextId: string | undefined) => {
      if (nextId === emailId) {
        return;
      }

      void navigate({
        search: (prev) =>
          nextId
            ? { ...prev, emailId: nextId }
            : { ...prev, emailId: undefined },
        replace: true,
      });
    },
    [emailId, navigate],
  );

  const matterData = matterDetails.data as unknown;
  const isDeletedMatter =
    Array.isArray(matterData) ||
    !(matterData as { id?: string } | undefined)?.id;
  useRedirectIfMatterDeleted({ matterId, isDeletedMatter });
  if (isDeletedMatter) {
    return null;
  }

  const matter = matterDetails.data;
  return (
    <MatterEmails
      matter={matter}
      selectedEmailId={emailId}
      onSelectedEmailIdChange={handleSelectedEmailIdChange}
    />
  );
}
